export class OpcoesAgendamento{
    opcoesDeDatas: Date[];
}